var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auction"},[_c('AuctionSettings',{ref:"auction",attrs:{"isOPS":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }